// extracted by mini-css-extract-plugin
export default {"container":"introduce_container__ZQR5p","text":"introduce_text__0kMT7","icon":"introduce_icon__XHJTL","album":"introduce_album__z7NFQ"};